<template>
  <v-card :style="backOpacity">
    <v-card-title v-if="type == 41"
      >マスターデータ検索フォームの設定</v-card-title
    >
    <v-card-title v-else>マスターデータの設定</v-card-title>
    <v-card-text>
      <v-container>
        <v-form ref="form" v-model="valid">
          <!-- {{ rules }} -->
          {{ values }}
          <v-row>
            <v-col cols="4">
              <v-text-field
                label="ラベル"
                v-model="returnData.label"
                :hint="type == 37 ? 'ラベルは出てきません' : ''"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <search-Page
                :label="'参照ページID'"
                v-model="returnData.init"
                searchPage
                required
              ></search-Page>
            </v-col>
          </v-row>
          <v-row>
            {{ type == 37 ? "※順番は影響しない" : "" }}
            指定したフォームIDの値を元にマスタを検索する
            <v-col cols="1">
              <v-btn @click="add" class="ma-2">追加</v-btn>
            </v-col>
            <v-col cols="1">
              <v-btn @click="del" class="ma-2">削除</v-btn>
            </v-col>
          </v-row>
          <div v-if="type == 41">
            <div v-for="(val, i) in values" :key="`1-${i}`">
              <v-row>
                <v-col cols="3">
                  <search-Page
                    label="検索項目"
                    v-model.number="values[i].masterID"
                    required
                    hint="検索対象のフォームID"
                  ></search-Page>
                </v-col>
                <!--
                  <v-col cols="3">
                    <search-Page
                      label="(同一ページ)検索データID"
                      v-model="values[i].valueID"
                      required
                      samePage
                    ></search-Page>
                  </v-col>
                  -->
                <v-col>
                  {{ i == 0 ? "必ず主キーとなるFormIDを選択" : "" }}
                  <v-radio-group label="" v-model="values[i].option" row>
                    <v-radio label="1単語検索" v-bind:value="'null'"></v-radio>
                    <v-radio label="完全一致" v-bind:value="'match'"></v-radio>
                    <v-radio
                      label="セレクトボックス"
                      v-bind:value="'selectBox'"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </div>
          </div>
          <!-- -------------------------------------->
          <div v-else>
            <div v-for="(val, i) in values" :key="`1-${i}`">
              <v-row>
                <v-col cols="3">
                  <search-Page
                    label="(マスタページ)検索対象フォームID"
                    v-model.number="values[i].masterID"
                    required
                  ></search-Page>
                </v-col>
                <v-col cols="3">
                  <search-Page
                    label="(同一ページ)検索データID"
                    v-model="values[i].valueID"
                    required
                    samePage
                  ></search-Page>
                </v-col>
                <v-col>
                  <v-radio-group label="" v-model="values[i].option" row>
                    <v-radio
                      v-if="type == 37"
                      label="完全一致"
                      v-bind:value="'match'"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </div>
            <hr />
          </div>

          <v-row>
            <v-col cols="4">
              <v-checkbox
                v-model="rulesFlag[0]"
                label="データ更新時に特定フォームに値を保存"
                value="true"
              ></v-checkbox>
            </v-col>
            <v-col v-if="rulesFlag[0] == 'true'" class="ma-2">
              <v-btn @click="add2" class="ma-2">追加</v-btn>
              <v-btn @click="del2" class="ma-2">削除</v-btn>
            </v-col>
            <v-col v-if="rulesFlag[0] == 'true'" class="ma-5">
              サブページの値をサブページに保存する場合<br />
              ターゲットFormID.サブページFormIDで指定
            </v-col>
          </v-row>
          <div v-if="rulesFlag[0] == 'true'">
            <div v-for="(ins, i) in insertValues" :key="`2-${i}`">
              <v-row>
                <v-col cols="4">
                  <search-Page
                    label="(マスタページ)挿入元フォームID"
                    v-model="ins.from"
                    required
                  ></search-Page>
                </v-col>
                <v-col cols="4">
                  <search-Page
                    label="(同一ページ)挿入先フォームID"
                    v-model="ins.to"
                    required
                    samePage
                  ></search-Page>
                </v-col>
                <v-col cols="3">
                  <v-col>
                    <v-radio-group label="" v-model="ins.op" row>
                      <v-radio label="なし" value="null"></v-radio>
                      <v-radio
                        label="新規作成時のみ代入"
                        value="newOnly"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        v-show="showButton"
        @click="submit"
        right
        x-large
        v-on:mouseover="backOpacity = 'opacity: 0.1'"
        v-on:mouseleave="backOpacity = 'opacity: 1'"
        >OK</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import searchPage from "./common/searchPage.vue";
export default {
  props: {
    //共通値
    type: Number,
    position: Number,
    label: String,
    //個別値
    value: String,
    init: String,
    rule: String,
  },
  components: {
    searchPage,
  },
  data() {
    return {
      returnData: {
        //共通値
        type: this.type,
        position: this.position,
        label: this.label,
        //個別値
        init: this.init,
        rule: this.rule,
        value: this.value,
      },
      rules: [null],
      rulesFlag: [false],
      //
      values: [
        {
          masterID: 0,
          valueID: "0",
          option: this.type == 37 ? "match" : "null",
        },
      ],
      insertValues: [{ from: 0, to: 0, op: "null" }],
      //マウスオーバー時
      backOpacity: "opacity: 1",
      showButton: false,
      //バリデーション
      valid: true,
      validation: {
        def: (value) => {
          return /^[\x]*$/.test(value) || "全角スペースが入っています";
        },
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
        required: (value) => !!value || "必須項目です",
      },
      headers: [],
    };
  },
  mounted() {
    //送信ボタンのカクツキ防止
    setTimeout(() => {
      this.showButton = true;
    }, 200);
    //
    if (typeof this.value != "undefined" && this.value != "") {
      this.values = JSON.parse(this.value);
    }
    //
    if (typeof this.rule != "undefined" && this.rule != "") {
      this.rulesFlag[0] = "true";
      this.insertValues = JSON.parse(this.rule);
    }
  },
  methods: {
    submit() {
      //バリデーション
      if (this.$refs.form.validate()) {
        if (this.rulesFlag[0]) {
          this.insertValues.map((i) => {
            i.from = String(i.from);
            i.to = String(i.to);
          });
          this.rules = JSON.stringify(this.insertValues);
        } else {
          this.rules = null;
        }
        this.returnData.value = JSON.stringify(this.values);
        this.returnData.rule = this.rules;
        this.$emit("clickSubmit", this.returnData);
      }
    },
    add() {
      this.values.push({
        masterID: 0,
        valueID: "0",
        option: this.type == 37 ? "match" : "null",
      });
    },
    del() {
      this.values.pop();
    },
    add2() {
      this.insertValues.push({ from: 0, to: 0, op: "null" });
    },
    del2() {
      if (this.insertValues.length >= 0) {
        this.insertValues.pop();
      }
    },
  },
};
</script>
